export const shouldRender = (data) => {
    return data.currentAccount.isUnlimited;
};
export const Component = function UnlimitedAccount() {
    return null;
};
//# sourceMappingURL=UnlimitedAccount.js.map
// @zapier/universal-layout@12.0.37 (fb08e5a7f)
